import {FC} from 'react';
//formik
import {Formik} from 'formik';
//form configuration
import {initialValues, validationSchema} from './formConfiguration';
//mui
import {Box, Link, Typography} from '@mui/material';
//constants
import {BODY1, BODY2, SIGN_UP, SIGN_UP_FREE, TEXT} from '@/utils/constants';
//components
import Button from '@/shared/components/Button';
import HeaderFormContent from '../../HeaderForm';
import SocialFormActions from '../../SocialFormActions';
import FormContent from './FormContent';
//helpers
import {ROUTER_URL, USER_TYPE} from '@/utils/enums';
//styles
import {loginFormStyle} from './LoginForm.styles';
import {ILoginForm} from '@/utils/types';

const LoginForm: FC<ILoginForm> = ({
  handleSubmitClickHandler,
  handleSignUpRedirect,
  onSocialLoginSuccess,
  userType = USER_TYPE.ORGANIZATION,
}) => {
  return (
    <Box sx={{...loginFormStyle.wrapper, ...(userType === USER_TYPE.ORGANIZATION ? loginFormStyle.marginTop : {})}}>
      <HeaderFormContent
        title="Welcome!"
        description={userType === USER_TYPE.ORGANIZATION ? 'Let’s get you logged in' : ''}
        sx={loginFormStyle.title}
      />

      <Formik initialValues={initialValues} onSubmit={handleSubmitClickHandler} validationSchema={validationSchema}>
        <FormContent />
      </Formik>

      <SocialFormActions userType={userType} onSocialLoginSuccess={onSocialLoginSuccess} />

      <Box sx={{...loginFormStyle.signUp, ...(userType === USER_TYPE.ORGANIZATION ? loginFormStyle.margin : {})}}>
        <Typography sx={loginFormStyle.login} variant={BODY1}>
          Don’t have an account yet?
        </Typography>
        {userType === USER_TYPE.ORGANIZATION ? (
          <Link href={ROUTER_URL.SIGN_UP} sx={loginFormStyle.link}>
            {SIGN_UP_FREE}
          </Link>
        ) : (
          <Button
            variant={TEXT}
            disableRipple
            sx={loginFormStyle.link}
            onClick={handleSignUpRedirect}
            title={SIGN_UP}
          />
        )}
      </Box>

      {userType === USER_TYPE.ORGANIZATION && (
        <Typography variant={BODY2} sx={loginFormStyle.email}>
          info@eventsimpli.com
        </Typography>
      )}

      <Box sx={loginFormStyle.footer}>
        <Link sx={loginFormStyle.text} href={ROUTER_URL.ORGANIZATION_PRIVACY_POLICY}>
          Privacy Policy
        </Link>
        <Link sx={loginFormStyle.text} href={ROUTER_URL.ORGANIZATION_TERMS_AND_CONDITIONS}>
          Terms & Conditions
        </Link>
      </Box>
    </Box>
  );
};

export default LoginForm;
